import { features } from "../constants/features";
import { parseShowroomWorkerBuildingGenOverride } from "./showroomWorkerBuildingGenQuery";

export function getDefaultShowroomWorkerBuildingGenEnabled(): boolean {
  return features.showroomWorkerBuildingGen.settings.defaultValue;
}

export function getShowroomWorkerBuildingGenEnabledFromSearch(search: string, defaultEnabled?: boolean): boolean {
  return (
    parseShowroomWorkerBuildingGenOverride(search) ?? defaultEnabled ?? getDefaultShowroomWorkerBuildingGenEnabled()
  );
}
